import request from '@/util/request2';
import {traversalTree} from '@/util/appUtils';
export const getAreaTree = () => {
  return request({
    url: '/api/auth/sysArea/getTree'
  }).then(res => {
    if (res.isSuccess()) {
      // 接口返回data是一个节点，需要转成数组
      const tree = [res.data];
      traversalTree({
        tree,
        callback: ({item}) => {
          // 需要将叶子节点的children属性删除,否则组件会多渲染一层
          if (Array.isArray(item.children) && item.children.length < 1) {
            Reflect.deleteProperty(item, 'children');
          }
        }
      });
    }
    return res;
  });
}

/**
 * 社区分页查询（查询全部）
 * @param params
 * @return {Promise}
 */
export const plCommunityPager = (params) => {
  return request({
    url: '/api/auth/plCommunity/pager',
    method: 'post',
    data: params
  });
}
/**
 * 地块分页查询
 * @param params
 * @returns {Promise}
 */
export const plPlotPager = (params) => {
  return request({
    url: '/api/auth/plPlot/pager',
    method: 'post',
    data: params
  });
};
/**
 * 申请记录分页查询
 * @param params
 * @returns {Promise}
 */
export const plApplyPager = (params) => {
  return request({
    url: '/api/auth/plApply/pager',
    method: 'post',
    data: params
  });
};
/**
 * 微信人员分页查询
 * @param params
 * @returns {Promise}
 */
export const wechatUserPager = (params) => {
  return request({
    url: '/api/auth/wechatUser/pager',
    method: 'post',
    data: params
  });
};
/**
 * 模版分页查询
 * @param params
 * @returns {Promise}
 */
export const msgTemplatePager = (params) => {
  return request({
    url: '/api/auth/plMsgTemplate/pager',
    method: 'post',
    data: params
  });
};
/**
 * 菜园分页查询
 * @param params
 * @returns {Promise}
 */
export const vegPagerWithFee = (params) => {
  return request({
    url: '/api/auth/plVeg/pagerWithFee',
    method: 'post',
    data: params
  });
};
/**
 * 分页查询菜园
 * @param params
 * @returns {Promise}
 */
export const vegPager = (params) => {
  return request({
    url: '/api/auth/plVeg/pager',
    method: 'post',
    data: params
  });
};